import { useData } from '../store';
import { LEFT_MS } from '../store/createStore';
import { useAuth } from '../auth/store';
import { useEffect, useState } from 'react';
import { doingLabel, lastSeen } from '../people';
import { Avatar } from './Avatar';
import { Tooltip } from './Tooltip';
import { Users } from 'lucide-react';
import { cn } from './cn';

const SIZE = 28;

// Кто ещё в приложении: пилюля с иконкой людей и стопкой кружков — читается как «кто в комнате»; никого — пилюли нет.
// Я — аватар с точкой связи в меню аккаунта. Всё остальное — в тултипах.
export function Presence() {
  const presence = useData((s) => s.presence);
  const me = useAuth((s) => s.profile?.id);
  const others = Object.values(presence).filter((p) => p.profile_id !== me).sort((a, b) => a.name.localeCompare(b.name));
  // стор чистит ушедших только по событиям присутствия — час без событий держал бы кружок дольше
  const left = Object.values(useData((s) => s.recentlyLeft)).filter((p) => p.left_at > Date.now() - LEFT_MS).sort((a, b) => b.left_at - a.left_at);
  // «last seen N min ago» в тултипе стареет — перерисовка раз в минуту, пока есть кого показывать
  const [, tick] = useState(0);
  useEffect(() => { if (left.length === 0) return; const t = setInterval(() => tick((n) => n + 1), 60_000); return () => clearInterval(t); }, [left.length]);
  if (others.length === 0 && left.length === 0) return null;
  return (
    <div className="flex items-center gap-1.5 h-9 pl-2.5 pr-1 rounded-full bg-gray-100 border border-gray-200" aria-label="Who else is here" data-presence-pill>
      <Users className="w-4 h-4 text-gray-500 shrink-0" aria-hidden />
      {/* каждый следующий кружок ложится под предыдущий: первые лица не перекрываются */}
      {others.map((p, i) => {
        const doing = doingLabel(p);
        return (
          <Tooltip key={p.profile_id} title={p.name} lines={[doing]} side="bottom">
          <span data-presence={p.profile_id} className={cn('relative inline-flex', i > 0 && '-ml-1.5')} style={{ zIndex: others.length - i }}>
            <Avatar name={p.name} color={p.color} src={p.avatar} size={SIZE} className="ring-2 ring-white" />
          </span>
          </Tooltip>
        );
      })}
      {left.map((p) => (
        <Tooltip key={p.profile_id} title={p.name} lines={[{ text: lastSeen(p.left_at), tone: 'muted' }]} side="bottom">
        <span data-presence-left={p.profile_id} className="relative inline-flex -ml-1.5 opacity-40 grayscale">
          <Avatar name={p.name} color={p.color} src={p.avatar} size={SIZE} className="ring-2 ring-white" />
        </span>
        </Tooltip>
      ))}
    </div>
  );
}
